export const ID_ADD = 'ID_ADD'
export const TOKEN_ADD = 'TOKEN_ADD'
export const PROJECT_ADD = 'PROJECT_ADD'
export const NEW_FILE = 'NEW_FILE'
export const APP_ACTIVE = 'APP_ACTIVE'
export const MAX_FILE = 'MAX_FILE'
export const SHOW_APP = 'SHOW_APP'
export const LOGIN_APP = 'LOGIN_APP'
export const ADD_ALIVE = 'ADD_ALIVE'
export const KEEP_FALSE = 'KEEP_FALSE'
export const NEW_PKG = 'NEW_PKG'
export const DONE_PKG = 'DONE_PKG'
export const ADD_SCROLL = 'ADD_SCROLL'
export const ALERT_WARN = 'ALERT_WARN'
export const SHOW_TRANSFER = 'SHOW_TRANSFER'
export const SET_INFO = 'SET_INFO'
export const SENT_FILE = 'SENT_FILE'
export const ACTIVE_ALIVE = 'ACTIVE_ALIVE'
export const ROLE_ADD = 'ROLE_ADD'
export const SHOW_LANG = 'SHOW_LANG'
export const ADD_SIZE = 'ADD_SIZE'
export const SHOW_DOWN = 'SHOW_DOWN'
// export const PASS_DOWN = 'PASS_DOWN'
//
export const USER_ADD = 'USER_ADD'
export const SPACE_ADD = 'SPACE_ADD'
export const PERMISSION_ADD = 'PERMISSION_ADD'
export const OTHER_SHOW = 'OTHER_SHOW'
export const SPACELIST_SHOW = 'SPACELIST_SHOW'
export const LEFT_SHOW = 'LEFT_SHOW'
export const BOX_SHOW = 'BOX_SHOW'
export const EL_UPDATE = 'EL_UPDATE'
export const VER_CHECK = 'VER_CHECK'
export const SHOW_KICK = 'SHOW_KICK'
export const SHOW_MSG = 'SHOW_MSG'
export const SHOW_FLOATING = 'SHOW_FLOATING'
export const EL_TRANSFER = 'EL_TRANSFER'
export const SHOW_DOWNMSG = 'SHOW_DOWNMSG'
